import { getItem, setItem } from "../../plugins/localStorage"
import { getSlideMetadata } from "../../plugins/powerpoint"

const state = {
  isActive: false,
  isActiveAuto: false,
  isActiveForAllQuestions: null,
  timer: 10,
  currentTimer: -1,
  isTimerAuto: false,
  isTimerForAllQuestions: null,
  isResults: false,
  refresh: false,
}

const getters = {}

const actions = {
  saveForThisQuestionOnly({ state, rootState, dispatch }, persist = false) {
    let optionsToSave = Object.assign({}, state)
    delete optionsToSave["currentTimer"]
    delete optionsToSave["isActiveForAllQuestions"]
    delete optionsToSave["isTimerForAllQuestions"]
    delete optionsToSave["refresh"]
    setItem({ name: "live[" + rootState.question.guid_text + "]", value: optionsToSave })

    if (persist === true) {
      // update question to DB
      dispatch("question/update", null, { root: true })
    }
  },

  saveForAllQuestion({ state, rootState }) {
    let optionsToSave = {}

    if (state.isActiveForAllQuestions !== null) {
      optionsToSave.isActiveAuto = state.isActiveAuto
      optionsToSave.activeSlideIndex = state.isActiveForAllQuestions ? 0 : rootState.app.slideMetadata.index
    }

    if (state.isTimerForAllQuestions !== null) {
      optionsToSave.timer = state.timer
      optionsToSave.timerSlideIndex = state.isTimerForAllQuestions ? 0 : rootState.app.slideMetadata.index
    }

    setItem({ name: "live", value: optionsToSave })
  },

  async setOptionsFromSaved({ commit, rootState }) {
    let options = getItem("live[" + rootState.question.guid_text + "]")
    if (options === null) {
      options = getItem("live")
      if (options !== null) {
        if (options.activeSlideIndex < rootState.app.slideMetadata.index) {
          delete options["isActiveAuto"]
        }
        if (options.timerSlideIndex < rootState.app.slideMetadata.index) {
          delete options["timer"]
        }
        delete options["activeSlideIndex"]
        delete options["timerSlideIndex"]
      }
    }

    if (options !== null) {
      commit("setOptions", options)
      if (options.isActive === true) {
        this.dispatch("socket/connect", null, { root: true })
      }
    }
  },

  async launchQuestion({ rootState }) {
    if (window.Office && rootState.pilot.event_guid === null) {
      //if (rootState.pilot.event_guid === null) {
      this.dispatch("socketppt/alert", "Merci de vous connecter d'abord à une réunion", { root: true })
      return
    }
    if (!window.Office && rootState.pilot.user === null) {
      await this.dispatch("pilot/login", null, { root: true })
    }
    this.commit("live/setActive")
  },
}

const mutations = {
  startTimer(state) {
    if (state.isActive === false) {
      return
    }

    this.dispatch("socket/startTimer", state.timer)
    state.currentTimer = state.timer
    setTimeout(() => this.commit("live/updateCurrentTimer"), 1000)
  },

  updateCurrentTimer(state) {
    if (state.currentTimer > 0) {
      state.currentTimer--
      setTimeout(() => this.commit("live/updateCurrentTimer"), 1000)
      return
    }

    if (state.currentTimer === 0) {
      state.currentTimer = -1
      state.isActive = false
      state.isResults = true
      this.dispatch("live/saveForThisQuestionOnly", true)
    }
  },

  setInactive(state, persist = true) {
    state.isResults = false
    state.isActive = false
    state.currentTimer = -1
    this.dispatch("socket/hideQuestion", null, { root: true })
    this.dispatch("live/saveForThisQuestionOnly", persist)
    this.commit("app/setIsOffline", true)
  },

  setActive(state) {
    if (state.isActive === true) {
      return
    }

    state.isActive = true
    this.commit("answers/removeAllEOL")

    // set question title
    if (window.Office) {
      getSlideMetadata((slideMetadata) => {
        this.commit("app/setSlideMetadata", slideMetadata)
        this.commit("question/setTitle", slideMetadata.title)
        this.dispatch("question/updateLocal", "title")
        this.commit("live/launchQuestion")
      })
    } else {
      this.commit("live/launchQuestion")
    }
  },

  async launchQuestion(state, options) {
    if (options !== undefined) {
      this.commit("live/setRefresh", options.refresh)
    }
    // await api save question etc.
    await this.dispatch("question/uploadToDB", null, { root: true })
    console.log("unstack done")
    if (options !== undefined && options.sync === true) {
      await this.dispatch("question/syncFromDb")
    }
    // then ws launch question
    this.dispatch("socket/connect", options !== undefined ? options.refresh : null, { root: true })
    if (state.isTimerAuto === true) {
      this.commit("live/startTimer")
    }
    this.dispatch("live/saveForThisQuestionOnly")
  },

  setIsActiveAuto(state, { isActiveAuto, isActiveForAllQuestions = null }) {
    state.isActiveAuto = isActiveAuto
    if (isActiveForAllQuestions !== null) {
      state.isActiveForAllQuestions = isActiveForAllQuestions
      this.dispatch("live/saveForAllQuestion")
    }
    this.dispatch("live/saveForThisQuestionOnly")
  },

  toggleIsTimerAuto(state) {
    state.isTimerAuto = !state.isTimerAuto
    this.dispatch("live/saveForThisQuestionOnly")
  },

  setTimer(state, { minutes, seconds, isTimerForAllQuestions = null }) {
    state.timer = parseInt(minutes) * 60 + parseInt(seconds)
    if (isTimerForAllQuestions !== null) {
      state.isTimerForAllQuestions = isTimerForAllQuestions
      this.dispatch("live/saveForAllQuestion")
    }
    this.dispatch("live/saveForThisQuestionOnly")
  },

  setOptions(state, options) {
    for (const property in options) {
      state[property] = options[property]
    }
    if (state.isActive === true) {
      this.commit("app/setIsOffline", false)
    }
  },

  setRefresh(state, value) {
    state.refresh = value
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
